<p-dialog
    [header]="header"
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [style]="{ width: '70vw' }"
    [breakpoints]="{ '960px': '90vw', '640px': '98vw' }"
    (onHide)="onHide()"
>
    <ng-container *ngIf="(sections?.length && data) || venue; else emptyState">
        <div class="vd-wrapper">
            <div class="vd-hero" *ngIf="venue?.venuePosterImage">
                <img
                    [src]="venue?.venuePosterImage"
                    [alt]="venue?.name || 'Venue poster'"
                />
            </div>

            <div class="vd-grid" *ngIf="sections?.length && data; else venueTemplate">
                <div class="vd-section" *ngFor="let section of sections">
                    <h6>{{ section.title }}</h6>
                    <div
                        class="vd-row"
                        *ngFor="let field of section.fields"
                        [hidden]="!shouldShowField(field)"
                    >
                        <span class="vd-label" *ngIf="showLabels">{{ field.label }}</span>
                        <span class="vd-value">
                            <ng-container [ngSwitch]="field.type || 'text'">
                                <ng-container *ngSwitchCase="'image'">
                                    <ng-container *ngIf="getValueByPath(data, field.path) as imageSrc; else noImage">
                                        <img
                                            *ngIf="isImageUrl(imageSrc)"
                                            class="vd-image"
                                            [src]="imageSrc"
                                            [alt]="field.label"
                                        />
                                        <video
                                            *ngIf="isVideoUrl(imageSrc)"
                                            class="vd-image"
                                            controls
                                            [src]="imageSrc"
                                            [attr.aria-label]="field.label"
                                        ></video>
                                        <span *ngIf="!isImageUrl(imageSrc) && !isVideoUrl(imageSrc)">
                                            {{ valueOrDash(imageSrc) }}
                                        </span>
                                        <a
                                            *ngIf="enableImageDownload"
                                            [href]="imageSrc"
                                            [download]="getImageDownloadName(field.label, imageSrc)"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            class="p-button p-component p-button-sm p-button-outlined mt-2 inline-flex align-items-center"
                                        >
                                            <span class="p-button-icon pi pi-download mr-2"></span>
                                            <span class="p-button-label">Download</span>
                                        </a>
                                    </ng-container>
                                    <ng-template #noImage>-</ng-template>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <ng-container [ngSwitch]="field.pipe">
                                <span *ngSwitchCase="'date'">
                                    {{ getValueByPath(data, field.path) | date: 'dd/MM/yyyy' }}
                                </span>
                                <span *ngSwitchCase="'datetime'">
                                    {{ getValueByPath(data, field.path) | date: 'dd/MM/yyyy, h:mm a' }}
                                </span>
                                <span *ngSwitchDefault>
                                    {{ valueOrDash(field.value ?? getValueByPath(data, field.path)) }}
                                </span>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </span>
                    </div>
                </div>
            </div>

            <ng-template #venueTemplate>
                <div class="vd-grid">
                    <div class="vd-section">
                        <h6>Basic</h6>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Name</span>
                            <span class="vd-value">{{ valueOrDash(venue?.name) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Venue Code</span>
                            <span class="vd-value">{{ valueOrDash(venue?.venueCode || venue?.venue_Code) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Category</span>
                            <span class="vd-value">{{ venueTypeLabel(venue?.category || venue?.venue_type) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Status</span>
                            <span class="vd-value">{{ valueOrDash(venue?.venueState) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Listing Status</span>
                            <span class="vd-value">{{ valueOrDash(venue?.listingStatus || venue?.listing_status) }}</span>
                        </div>
                    </div>

                    <div class="vd-section">
                        <h6>Address</h6>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Line 1</span>
                            <span class="vd-value">{{ valueOrDash(venue?.address?.line1) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Line 2</span>
                            <span class="vd-value">{{ valueOrDash(venue?.address?.line2) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">City</span>
                            <span class="vd-value">{{ valueOrDash(venue?.address?.city) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">State</span>
                            <span class="vd-value">{{ valueOrDash(venue?.address?.state) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Country</span>
                            <span class="vd-value">{{ valueOrDash(venue?.address?.country) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Pincode</span>
                            <span class="vd-value">{{ valueOrDash(venue?.address?.pincode) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Zone</span>
                            <span class="vd-value">{{ valueOrDash(venue?.address?.zone) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Area Code</span>
                            <span class="vd-value">{{ valueOrDash(venue?.address?.areaCode) }}</span>
                        </div>
                    </div>

                    <div class="vd-section">
                        <h6>Geolocation</h6>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Latitude</span>
                            <span class="vd-value">{{ valueOrDash(venue?.geolocation?.latitude) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Longitude</span>
                            <span class="vd-value">{{ valueOrDash(venue?.geolocation?.longitude) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Map Link</span>
                            <span class="vd-value">{{ valueOrDash(venue?.geolocation?.nameasinMap) }}</span>
                        </div>
                    </div>

                    <div class="vd-section">
                        <h6>Business Details</h6>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Company Name</span>
                            <span class="vd-value">{{ valueOrDash(venue?.businessDetails?.companyName) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">GST Number</span>
                            <span class="vd-value">{{ valueOrDash(venue?.businessDetails?.gSTNumber) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Bank Account Name</span>
                            <span class="vd-value">{{ valueOrDash(venue?.businessDetails?.bankAccountName) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Bank Name</span>
                            <span class="vd-value">{{ valueOrDash(venue?.businessDetails?.bankName) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Account Number</span>
                            <span class="vd-value">{{ valueOrDash(venue?.businessDetails?.bankAccountNumber) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Bank Address</span>
                            <span class="vd-value">{{ valueOrDash(venue?.businessDetails?.bankAddress) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">IFSC Code</span>
                            <span class="vd-value">{{ valueOrDash(venue?.businessDetails?.bankIFSCCode) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Contact Email</span>
                            <span class="vd-value">{{ valueOrDash(venue?.businessDetails?.contactEmail) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Contact Number</span>
                            <span class="vd-value">{{ valueOrDash(venue?.businessDetails?.contactNumber?.number) }}</span>
                        </div>
                    </div>

                    <div class="vd-section">
                        <h6>Operations</h6>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Start Date</span>
                            <span class="vd-value">{{ venue?.startdate | date: 'dd/MM/yyyy, h:mm a' }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">End Date</span>
                            <span class="vd-value">{{ venue?.enddate | date: 'dd/MM/yyyy, h:mm a' }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Opening Hours</span>
                            <span class="vd-value">{{ valueOrDash(venue?.openingHours) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Closing Hours</span>
                            <span class="vd-value">{{ valueOrDash(venue?.closingHours) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Listing Date</span>
                            <span class="vd-value">{{ venue?.listingDate | date: 'dd/MM/yyyy, h:mm a' }}</span>
                        </div>
                    </div>

                    <div class="vd-section">
                        <h6>Capacity & Ratings</h6>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Capacity Per Hour</span>
                            <span class="vd-value">{{ valueOrDash(venue?.capacityPerHour) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Occupancy %</span>
                            <span class="vd-value">{{ valueOrDash(venue?.occupancyPercentage) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Slot Availability %</span>
                            <span class="vd-value">{{ valueOrDash(venue?.slotAvailabilityPercentage) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Rating</span>
                            <span class="vd-value">{{ valueOrDash(venue?.venueRating) }}</span>
                        </div>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Checked-in Users</span>
                            <span class="vd-value">{{ valueOrDash(venue?.checkedInUsers) }}</span>
                        </div>
                    </div>

                    <div class="vd-section">
                        <h6>Owners</h6>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Owner Name</span>
                            <span class="vd-value">{{ formatList(venue?.ownersName || venue?.owners) }}</span>
                        </div>
                       
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels"> BDM /Venue Managers </span>
                            <span class="vd-value">{{ formatList(venue?.bDMManagersName || venue?.bDMManagers) }}</span>
                        </div>
                        
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Zonal Manager/ Sales Manager Name</span>
                            <span class="vd-value">{{ formatList(venue?.zonalSalesManagersName || venue?.zonalSalesManagers) }}</span>
                        </div>
                    </div>

                    <div class="vd-section">
                        <h6>Amenities</h6>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">Amenities</span>
                            <span class="vd-value">{{ formatList(venue?.amenities) }}</span>
                        </div>
                    </div>

                    <div class="vd-section">
                        <h6>Description</h6>
                        <div class="vd-row">
                            <span class="vd-label" *ngIf="showLabels">About</span>
                            <span class="vd-value">{{ valueOrDash(venue?.description) }}</span>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </ng-container>

    <ng-template #emptyState>
        <div class="vd-empty">No details available.</div>
    </ng-template>
</p-dialog>
